import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-lg px-4 pb-24 pt-32 sm:px-6" data-testid="payment-cancel-page">
      <div className="rounded-xl border border-slate-200 bg-white p-10 text-center shadow-sm">
        <XCircle className="mx-auto h-12 w-12 text-slate-400" aria-hidden="true" />
        <h1 className="mt-5 font-display text-2xl font-bold tracking-tight text-slate-900">
          Checkout cancelled
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">
          No money was captured and your booking is saved. You can pay anytime from My Bookings,
          or choose to pay at the service desk.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/my-bookings"
            data-testid="cancel-my-bookings-link"
            className="rounded-md bg-blue-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800"
          >
            My Bookings
          </Link>
          <Link
            to="/book"
            data-testid="cancel-book-again-link"
            className="rounded-md border-2 border-slate-300 px-5 py-2.5 text-sm font-medium text-slate-700 hover:border-blue-900 hover:text-blue-900"
          >
            Book another service
          </Link>
        </div>
      </div>
    </div>
  );
}
